import type { FC } from 'react';
import * as Styled from './styled';
import type { DetailListProps } from './types';
import { WhatsappButton } from '../WhatsappButton';

export * from './types';

export const DetailList: FC<DetailListProps> = (props) => {
  const {
    items,
    labelClassName,
    wrap = true,
    onWhatsappClick,
    enableWhatsAppContact = false,
    ...rest
  } = props;
  return (
    <Styled.Container {...rest}>
      {items.map((item, index) => (
        <Styled.Wrapper wrap={wrap.toString()} key={index}>
          <Styled.Label wrap={wrap.toString()} className={labelClassName}>
            {item.labelIcon && <Styled.LabelIconWrapper>{item.labelIcon}</Styled.LabelIconWrapper>}
            {item.label}
          </Styled.Label>
          <Styled.Value wrap={wrap.toString()}>{item.value ?? '-'}</Styled.Value>
        </Styled.Wrapper>
      ))}
      {enableWhatsAppContact ? (
        <Styled.WhatsAppContainer>
          <WhatsappButton outlined={false} onClick={onWhatsappClick} />
        </Styled.WhatsAppContainer>
      ) : null}
    </Styled.Container>
  );
};
